import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import axios from 'axios';
import { Zap, Check, AlertCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

const API = `${window.location.origin}/api`;

export default function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const [status, setStatus] = useState('verifying');
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    if (!token) { setStatus('error'); setErrorMsg('No verification token found in the URL.'); return; }
    axios.post(`${API}/auth/verify-email`, { token })
      .then(() => setStatus('success'))
      .catch((e) => {
        setStatus('error');
        const detail = e.response?.data?.detail;
        setErrorMsg(typeof detail === 'string' ? detail : 'Verification failed. Please try again or request a new link.');
      });
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center px-4" data-testid="verify-email-page">
      <div className="w-full max-w-md text-center">
        <div className="flex items-center justify-center gap-2 mb-8">
          <Zap className="w-6 h-6 text-[hsl(var(--accent))]" strokeWidth={2.5} />
          <span className="text-2xl font-bold tracking-tight" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>ZipAI</span>
        </div>
        {status === 'verifying' && (
          <div data-testid="verify-loading">
            <div className="w-8 h-8 border-2 border-foreground border-t-transparent rounded-full animate-spin mx-auto mb-4" />
            <p className="text-muted-foreground">Verifying your email...</p>
          </div>
        )}
        {status === 'success' && (
          <div data-testid="verify-success">
            <div className="w-12 h-12 rounded-full bg-[hsl(var(--success))]/20 flex items-center justify-center mx-auto mb-4">
              <Check className="w-6 h-6 text-[hsl(var(--success))]" />
            </div>
            <h1 className="text-3xl font-black tracking-tight mb-3" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>Email verified</h1>
            <p className="text-muted-foreground mb-2">Your email has been verified successfully.</p>
            <p className="text-sm text-muted-foreground mb-6">An administrator will now review and approve your account. You will receive an email once approved.</p>
            <Link to="/login"><Button className="rounded-[4px]" data-testid="go-to-login-btn">Go to login</Button></Link>
          </div>
        )}
        {status === 'error' && (
          <div data-testid="verify-error">
            <div className="w-12 h-12 rounded-full bg-amber-500/20 flex items-center justify-center mx-auto mb-4">
              <AlertCircle className="w-6 h-6 text-amber-500" />
            </div>
            <h1 className="text-3xl font-black tracking-tight mb-3" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>Verification notice</h1>
            <p className="text-muted-foreground mb-6">{errorMsg}</p>
            <Link to="/login"><Button className="rounded-[4px]" data-testid="go-to-login-btn">Go to login</Button></Link>
          </div>
        )}
        <p className="mt-16 text-xs text-muted-foreground/60 tracking-wide">Powered By Cuvano&reg;</p>
      </div>
    </div>
  );
}
